module.exports = __webpack_public_path__ + "67d2607c3687fea0c2e70611c32711b3.jpg";